import './style.scss'

const Introduce = () => {
  return (
    <>
      <div id='scrollspy_introduce' style={{ marginBottom: '66px' }}></div>

      <div className='introduce_box'>
        <div className='introduce'>
          <h2>Giới thiệu</h2>
          <h1>Nhôm đúc BMT</h1>
          <p className='introduce_content'>
            Chào mừng đến với Nhôm Đúc BMT! Chúng tôi là đơn vị chuyên thi công và sản xuất các sản phẩm nhôm đúc cao
            cấp, kết hợp giữa tính thẩm mỹ, độ bền và công nghệ hiện đại. Với nhiều năm kinh nghiệm cùng đội ngũ kỹ
            thuật viên tay nghề cao, thương hiệu luôn mang đến những giải pháp tối ưu, phù hợp với từng công trình. Nhôm
            Đúc BMT không ngừng ứng dụng công nghệ tiên tiến và quy trình sản xuất hiện đại để tạo ra các sản phẩm chất
            lượng cao – từ chi tiết nhỏ đến những hạng mục lớn, đáp ứng đầy đủ các tiêu chuẩn về kỹ thuật và thẩm mỹ.
            Chúng tôi cung cấp dịch vụ trọn gói, bao gồm: thiết kế, gia công và lắp đặt theo yêu cầu. Mỗi sản phẩm đều
            được chế tác từ nguyên liệu tuyển chọn, đảm bảo độ bền vượt trội, khả năng chịu lực tốt và thích nghi với
            mọi điều kiện thời tiết. Với phương châm “Uy tín – Chất lượng – Tận tâm”, chúng tôi luôn lắng nghe và đồng
            hành cùng khách hàng để kiến tạo nên những công trình bền đẹp theo thời gian. Nhôm Đúc BMT – Sự lựa chọn lý
            tưởng cho mọi công trình kiến trúc.
          </p>
          <p className='introduce_seo'>
            Nhôm đúc BMT chúng tôi có địa chỉ tại Buôn Ma Thuột, Đắk Lắk nhận thi công Toàn Quốc. Với dày dặn kinh
            nghiệm, đội ngũ lành nghề và ưu thế về nguồn nguyên vật liệu cả về giá và chất lượng. Chúng tôi cam kết sẽ
            mang đến khách hàng những sản phẩm PHÙ HỢP & CHẤT LƯỢNG nhất thị trường hiện nay.
          </p>
          <div className='introduce_experience'>
            <div className='introduce_experience_1'>
              <h3>10+</h3>
              <p>Năm kinh nghiệm</p>
            </div>
            <div className='introduce_experience_2'>
              <h3>6000+</h3>
              <p>Công trình hoàn thiện</p>
            </div>
          </div>
        </div>
        <div className='introduce_img'>
          <img src={process.env.PUBLIC_URL + '/images/introduce.png'} alt='thi-cong-nhom-duc-tot-nhat-bmt-dak-lak' />
        </div>
      </div>
    </>
  )
}

export default Introduce
